import { render, staticRenderFns } from "./Rules.vue?vue&type=template&id=7b6e1464&scoped=true"
import script from "./Rules.vue?vue&type=script&lang=js"
export * from "./Rules.vue?vue&type=script&lang=js"
import style0 from "./Rules.vue?vue&type=style&index=0&id=7b6e1464&lang=scss&scoped=true"
import style1 from "./Rules.vue?vue&type=style&index=1&id=7b6e1464&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b6e1464",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\projects\\web_h5\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7b6e1464')) {
      api.createRecord('7b6e1464', component.options)
    } else {
      api.reload('7b6e1464', component.options)
    }
    module.hot.accept("./Rules.vue?vue&type=template&id=7b6e1464&scoped=true", function () {
      api.rerender('7b6e1464', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/P2_Page/Invite/Rules.vue"
export default component.exports